<template>
    <div style="height:100%">
        <a-breadcrumb class="breadcrumb">
            <a-breadcrumb-item>首页</a-breadcrumb-item>
            <a-breadcrumb-item>招生咨询</a-breadcrumb-item>
            <a-breadcrumb-item>企微群发</a-breadcrumb-item>
        </a-breadcrumb>
        <div class="main-body">
            <a-tabs :animated="false" :activeKey="acitveKey" @change="changeTab">
                <a-tab-pane tab="客户群发" key="1">
                    <user v-if="acitveKey === '1'"/>
                </a-tab-pane>
                <a-tab-pane tab="客户群群发" key="2">
                    <group v-if="acitveKey === '2'"/>
                </a-tab-pane>
                <a-tab-pane tab="客户朋友圈" key="3">
                    <friend v-if="acitveKey === '3'"/>
                </a-tab-pane>
            </a-tabs>
        </div>
    </div>
</template>

<script>
    import user from './user'
    import group from './group'
    import friend from './friend'

    export default {
        name:'invite',
        components: {
            user,
            group,
            friend
        },
        data() {
            return {
                acitveKey: '1'
            }
        },
        created () {
            if(this.$ls.get('sendmessage')){
                this.acitveKey = this.$ls.get('sendmessage')
            }
        },
        methods: {
            changeTab(key) {
                this.acitveKey = key
                this.$ls.set('sendmessage',key)
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>